
export default {
  props: {
    // 组件样式
    styleObject: {
      type: Object,
      required: false,
      default: () => {},
    },
    // 文本样式
    styleTitleObject: {
      type: Object,
      required: false,
      default: () => {},
    },
    src: {
      type: String,
      default: () => {
        return ''
      },
    },
    title: {
      type: String,
      default: () => {
        return ''
      },
    },
  },
}
